import { useQuery } from "@tanstack/react-query";
import * as React from "react";
import { Helmet } from "react-helmet";
import { NavLink, Outlet, useLocation } from "react-router-dom";
import Footer from "../../components/footer";
import Header from "../../components/header";
import Spinner from "../../components/spinner";
import TopNavabr from "../../components/topNavabr";
import { aboutNestedRoutes } from "../../data/about-nested-routes";
import { BASE_URL } from "../../data/baseURL";
import { useScrollTop } from "../../hook/useScrollTop";
export const AboutDataContext = React.createContext();

const About = () => {
  const { data, isLoading, isError } = useQuery(["aboutPage"], async () => {
    const response = await window.fetch(`${BASE_URL}/about`);
    return await response.json();
  });
  const location = useLocation();
  const currentRoute = location.pathname.split("/")[2].replaceAll("-", " ");
  useScrollTop();

  if (isLoading) {
    return <Spinner />;
  }

  if (isError) {
    throw new Error();
  }

  const { image, video, default: defaultValue } = data?.about?.about_banner;

  return (
    <>
      <Helmet>
        <title>AFRO || About</title>
      </Helmet>
      <TopNavabr />
      <Header
        bannerBackground={Boolean(defaultValue) ? "video" : "image"}
        videoURL={video}
        imageURL={image}
      >
        <div className="pt-7 pb-5 text-center">
          <div className="header-background-image-size">
            <h4 className="mt-5 fs-14 gilroy-bold ls-0 text-uppercase">
              {data?.home?.page_name}
            </h4>
            <h1 className="fs-56 mt-4 text-capitalize">{currentRoute}</h1>
          </div>
        </div>
      </Header>
      <div className="row g-0">
        <aside className="col-12 d-none d-lg-block col-lg-2 h-full border-end">
          <ul
            className="list-style-none"
            style={{ margin: "0 -0.5px 0px -20px" }}
          >
            <li className="fs-14 mt-4 border-bottom pb-4 ps-3">ABOUT US</li>
            {aboutNestedRoutes.map((route) => (
              <li className="border-bottom side-menu ps-2" key={route.id}>
                <NavLink
                  end
                  to={route.link}
                  className={({ isActive }) =>
                    isActive
                      ? "border-right-yellow d-block text-decoration-none py-3 text-orange-ryb fs-16 fw-bold"
                      : "text-secondary text-decoration-none fs-16 py-3 d-block"
                  }
                >
                  {route.label}
                </NavLink>
              </li>
            ))}
          </ul>
        </aside>
        <div className="col-12 col-lg-10 pb-7">
          <AboutDataContext.Provider value={{ ...data?.about }}>
            <Outlet />
          </AboutDataContext.Provider>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default About;
